module.exports = __webpack_public_path__ + "img/safety-bg-mobile-2x.f237bc66.png";